
//自己算一下预计可实现收入
function getExpectIncomeValue(amount,pct) {
  if(!pct || !amount) {
    return '0';
  }
  let index = pct.indexOf('%');
  let pctNumber;
  if(index == -1) {
    pctNumber = parseFloat(pct);
  } else {
    pctNumber = parseFloat(pct.substring(0, index));
  }

  let value = pctNumber * parseFloat(amount);

  return value.toFixed(2);
}

export function formatEarningCostCheckTableData(detail) {
  let res = [];
  // 预算金额
  res.push({
    title1: '预算金额',
    title2: '合同金额',
    data: detail.projectAmount,
    remark: '',
    rowspan: 12,
    myindex: 1
  });
  res.push({
    title1: '预算金额',
    title2: '暂定金金额',
    data: detail.provisionalAmount,
    remark: '',
    rowspan: 0,
    myindex: 1
  });
  res.push({
    title1: '预算金额',
    title2: '合同变更额',
    data: detail.changeAmount,
    remark: '',
    rowspan: 0,
    myindex: 1
  });
  res.push({
    title1: '预算金额',
    title2: '清单复核金额',
    data: detail.listCheckAmount,
    remark: '',
    rowspan: 0,
    myindex: 1
  });
  res.push({
    title1: '预算金额',
    title2: '合同物价指数金额',
    data: detail.contractPriceIndexAmount,
    remark: '',
    rowspan: 0,
    myindex: 1
  });
  res.push({
    title1: '预算金额',
    title2: '审计金额',
    data: detail.auditAmount,
    remark: '',
    rowspan: 0,
    myindex: 1
  });
  res.push({
    title1: '预算金额',
    title2: '收入确认基数',
    data: detail.earningCheckBase,
    remark: '',
    rowspan: 0,
    myindex: 1
  });
  res.push({
    title1: '预算金额',
    title2: '预计合同总收入',
    data: detail.expectEarningAmount,
    remark: '',
    rowspan: 0,
    myindex: 1
  });
  res.push({
    title1: '预算金额',
    title2: '比例',
    data: detail.expectIncomePct,
    remark: '',
    rowspan: 0,
    myindex: 1
  });
  res.push({
    title1: '预算金额',
    title2: '预计可实现收入',
    data: detail.expectIncome, //getExpectIncomeValue(detail.expectEarningAmount, detail.expectIncomePct),
    remark: '',
    rowspan: 0,
    myindex: 1
  });
  res.push({
    title1: '预算金额',
    title2: '预计合同总成本',
    data: detail.expectCostAmount,
    remark: '',
    rowspan: 0,
    myindex: 1
  });
  res.push({
    title1: '预算金额',
    title2: '预计合同总毛利',
    data: detail.expectProfitAmount,
    remark: '',
    rowspan: 0,
    myindex: 1
  });

  // 实际成本
  res.push({
    title1: '实际成本',
    title2: '期末累计发生实际成本',
    data: detail.endActCost,
    remark: '',
    rowspan: 1,
    myindex: 2,
  })

  res.push({
    title1: '',
    title2: '完工百分比',
    data: detail.finishPct,
    isPct: true,
    remark: '',
    rowspan: 1,
    myindex: 3,
  })

  // 累计应确认

  res.push({
    title1: '累计应确认',
    title2: '合同收入（主营业务收入）',
    data: detail.alreadyTotalCheck ? detail.alreadyTotalCheck.earningAmount : 0,
    remark: '',
    rowspan: 3,
    myindex: 4,
  })
  res.push({
    title1: '累计应确认',
    title2: '合同费用（主营业务成本）',
    data: detail.alreadyTotalCheck ? detail.alreadyTotalCheck.costAmount : 0,
    remark: '',
    rowspan: 0,
    myindex: 4,
  })
  res.push({
    title1: '累计应确认',
    title2: '合同毛利',
    data: detail.alreadyTotalCheck ? detail.alreadyTotalCheck.profitAmount : 0,
    remark: '',
    rowspan: 0,
    myindex: 4,
  })

  // 以前已确认
  res.push({
    title1: '以前已确认',
    title2: '合同收入（主营业务收入）',
    data: detail.historyCheck ? detail.historyCheck.earningAmount : 0,
    remark: '',
    rowspan: 3,
    myindex: 5,
  })
  res.push({
    title1: '以前已确认',
    title2: '合同费用（主营业务成本）',
    data: detail.historyCheck ? detail.historyCheck.costAmount : 0,
    remark: '',
    rowspan: 0,
    myindex: 5,
  })
  res.push({
    title1: '以前已确认',
    title2: '合同毛利',
    data: detail.historyCheck ? detail.historyCheck.profitAmount : 0,
    remark: '',
    rowspan: 0,
    myindex: 5,
  })

  // 当期应确认

  res.push({
    title1: '当期应确认',
    title2: '合同收入（主营业务收入）',
    data: detail.currentCheck ? detail.currentCheck.earningAmount : 0,
    remark: '',
    rowspan: 3,
    myindex: 6,
  })
  res.push({
    title1: '当期应确认',
    title2: '合同费用（主营业务成本）',
    data: detail.currentCheck ? detail.currentCheck.costAmount : 0,
    remark: '',
    rowspan: 0,
    myindex: 6,
  })
  res.push({
    title1: '当期应确认',
    title2: '合同毛利',
    data: detail.currentCheck ? detail.currentCheck.profitAmount : 0,
    remark: '',
    rowspan: 0,
    myindex: 6,
  })

  return res;
}


export function formatEarningCostGatherTableData(detail) {
  let res = [];

  res.push({
    title: '合同金额',
    data1: detail.projectAmount ? detail.projectAmount.taxAmount : 0,
    data2: detail.projectAmount ? detail.projectAmount.noTaxAmount : 0,
    remark: ''
  })

  res.push({
    title: '暂定金金额',
    data1: detail.provisionalAmount ? detail.provisionalAmount.taxAmount : 0,
    data2: detail.provisionalAmount ? detail.provisionalAmount.noTaxAmount : 0,
    remark: ''
  })

  res.push({
    title: '变更金额',
    data1: detail.changeAmount ? detail.changeAmount.taxAmount : 0,
    data2: detail.changeAmount ? detail.changeAmount.noTaxAmount : 0,
    remark: ''
  })

  res.push({
    title: '审计金额',
    data1: detail.auditAmount ? detail.auditAmount.taxAmount : 0,
    data2: detail.auditAmount ? detail.auditAmount.noTaxAmount : 0,
    remark: ''
  })

  res.push({
    title: '预计总收入',
    data1: detail.expectIncomeAmount ? detail.expectIncomeAmount.taxAmount : 0,
    data2: detail.expectIncomeAmount ? detail.expectIncomeAmount.noTaxAmount : 0,
    remark: ''
  })

  res.push({
    title: '预计总成本',
    data1: detail.expectCostAmount ? detail.expectCostAmount.taxAmount : 0,
    data2: detail.expectCostAmount ? detail.expectCostAmount.noTaxAmount : 0,
    remark: ''
  })

  res.push({
    title: '已结算金额',
    data1: detail.settleAmount ? detail.settleAmount.taxAmount : 0,
    data2: detail.settleAmount ? detail.settleAmount.noTaxAmount : 0,
    remark: ''
  })

  res.push({
    title: '累计已付款金额',
    data1: detail.alreadyPayAmount ? detail.alreadyPayAmount.taxAmount : 0,
    data2: detail.alreadyPayAmount ? detail.alreadyPayAmount.noTaxAmount : 0,
    remark: ''
  })

  return res;
}

export function formatEarningCostDetailTableData(detail) {
  let res = []

  res.push({
    title1: '工程进展',
    title2: detail.projectProcess || '',
    span1: {
      rowspan: 1,
      colspan: 1
    },
    span2: {
      rowspan: 1,
      colspan: 1
    },
    myindex:1
  })

  res.push({
    title1: '合同金额',
    title2: '',
    span1: {
      rowspan: 1,
      colspan: 2
    },
    span2: {
      rowspan: 0,
      colspan: 0
    },
    myindex: 2,
    budgetTaxAmount: detail.projectAmount ? detail.projectAmount.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.projectAmount ? detail.projectAmount.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.projectAmount ? detail.projectAmount.actTaxAmount : 0,
    actNoTaxAmount: detail.projectAmount ? detail.projectAmount.actNoTaxAmount : 0,
    remark: detail.projectAmount ? detail.projectAmount.remark : ''
  })

  res.push({
    title1: '暂定金（变更金额）',
    title2: '',
    span1: {
      rowspan: 1,
      colspan: 2
    },
    span2: {
      rowspan: 0,
      colspan: 0
    },
    myindex:3,
    budgetTaxAmount: detail.provisionalAmount ? detail.provisionalAmount.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.provisionalAmount ? detail.provisionalAmount.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.provisionalAmount ? detail.provisionalAmount.actTaxAmount : 0,
    actNoTaxAmount: detail.provisionalAmount ? detail.provisionalAmount.actNoTaxAmount : 0,
    remark: detail.provisionalAmount ? detail.provisionalAmount.remark : ''
  })

  res.push({
    title1: '清单复核金额',
    title2: '',
    span1: {
      rowspan: 1,
      colspan: 2
    },
    span2: {
      rowspan: 0,
      colspan: 0
    },
    myindex:4,
    budgetTaxAmount: detail.listCheckAmount ? detail.listCheckAmount.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.listCheckAmount ? detail.listCheckAmount.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.listCheckAmount ? detail.listCheckAmount.actTaxAmount : 0,
    actNoTaxAmount: detail.listCheckAmount ? detail.listCheckAmount.actNoTaxAmount : 0,
    remark: detail.listCheckAmount ? detail.listCheckAmount.remark : ''
  })

  res.push({
    title1: '合同物价指数金额',
    title2: '',
    span1: {
      rowspan: 1,
      colspan: 2
    },
    span2: {
      rowspan: 0,
      colspan: 0
    },
    myindex:5,
    budgetTaxAmount: detail.contractPriceIndexAmount ? detail.contractPriceIndexAmount.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.contractPriceIndexAmount ? detail.contractPriceIndexAmount.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.contractPriceIndexAmount ? detail.contractPriceIndexAmount.actTaxAmount : 0,
    actNoTaxAmount: detail.contractPriceIndexAmount ? detail.contractPriceIndexAmount.actNoTaxAmount : 0,
    remark: detail.contractPriceIndexAmount ? detail.contractPriceIndexAmount.remark : ''
  })

  res.push({
    title1: '审计金额',
    title2: '',
    span1: {
      rowspan: 1,
      colspan: 2
    },
    span2: {
      rowspan: 0,
      colspan: 0
    },
    myindex:6,
    budgetTaxAmount: detail.auditAmount ? detail.auditAmount.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.auditAmount ? detail.auditAmount.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.auditAmount ? detail.auditAmount.actTaxAmount : 0,
    actNoTaxAmount: detail.auditAmount ? detail.auditAmount.actNoTaxAmount : 0,
    remark: detail.auditAmount ? detail.auditAmount.remark : ''
  })

  res.push({
    title1: '合同总收入金额',
    title2: '',
    span1: {
      rowspan: 1,
      colspan: 2
    },
    span2: {
      rowspan: 0,
      colspan: 0
    },
    myindex:7,
    budgetTaxAmount: detail.contractTotalIncomeAmount ? detail.contractTotalIncomeAmount.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.contractTotalIncomeAmount ? detail.contractTotalIncomeAmount.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.contractTotalIncomeAmount ? detail.contractTotalIncomeAmount.actTaxAmount : 0,
    actNoTaxAmount: detail.contractTotalIncomeAmount ? detail.contractTotalIncomeAmount.actNoTaxAmount : 0,
    remark: detail.contractTotalIncomeAmount ? detail.contractTotalIncomeAmount.remark : ''
  })

  res.push({
    title1: '直接成本',
    title2: '劳务费',
    span1: {
      rowspan: 5,
      colspan: 1
    },
    span2: {
      rowspan: 1,
      colspan: 1
    },
    myindex:8,
    budgetTaxAmount: detail.serviceAmount ? detail.serviceAmount.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.serviceAmount ? detail.serviceAmount.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.serviceAmount ? detail.serviceAmount.actTaxAmount : 0,
    actNoTaxAmount: detail.serviceAmount ? detail.serviceAmount.actNoTaxAmount : 0,
    remark: detail.serviceAmount ? detail.serviceAmount.remark : '',
    contractAmount: detail.serviceAmount ? detail.serviceAmount.contractAmount : 0
  })

  res.push({
    title1: '直接成本',
    title2: '材料费',
    span1: {
      rowspan: 0,
      colspan: 0
    },
    span2: {
      rowspan: 1,
      colspan: 1
    },
    myindex:8,
    budgetTaxAmount: detail.materialAmount ? detail.materialAmount.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.materialAmount ? detail.materialAmount.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.materialAmount ? detail.materialAmount.actTaxAmount : 0,
    actNoTaxAmount: detail.materialAmount ? detail.materialAmount.actNoTaxAmount : 0,
    remark: detail.materialAmount ? detail.materialAmount.remark : '',
    contractAmount: detail.materialAmount ? detail.materialAmount.contractAmount : 0
  })

  res.push({
    title1: '直接成本',
    title2: '机械使用费',
    span1: {
      rowspan: 0,
      colspan: 0
    },
    span2: {
      rowspan: 1,
      colspan: 1
    },
    myindex:8,
    budgetTaxAmount: detail.machineAmount ? detail.machineAmount.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.machineAmount ? detail.machineAmount.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.machineAmount ? detail.machineAmount.actTaxAmount : 0,
    actNoTaxAmount: detail.machineAmount ? detail.machineAmount.actNoTaxAmount : 0,
    remark: detail.machineAmount ? detail.machineAmount.remark : '',
    contractAmount: detail.machineAmount ? detail.machineAmount.contractAmount : 0
  })

  res.push({
    title1: '直接成本',
    title2: '其他直接费',
    span1: {
      rowspan: 0,
      colspan: 0
    },
    span2: {
      rowspan: 1,
      colspan: 1
    },
    myindex:8,
    budgetTaxAmount: detail.otherDirectAmount ? detail.otherDirectAmount.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.otherDirectAmount ? detail.otherDirectAmount.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.otherDirectAmount ? detail.otherDirectAmount.actTaxAmount : 0,
    actNoTaxAmount: detail.otherDirectAmount ? detail.otherDirectAmount.actNoTaxAmount : 0,
    remark: detail.otherDirectAmount ? detail.otherDirectAmount.remark : '',
    contractAmount: detail.otherDirectAmount ? detail.otherDirectAmount.contractAmount : 0
  })

  res.push({
    title1: '直接成本',
    title2: '小计',
    span1: {
      rowspan: 0,
      colspan: 0
    },
    span2: {
      rowspan: 1,
      colspan: 1
    },
    myindex:8,
    budgetTaxAmount: detail.tableTwoDirectTotal ? detail.tableTwoDirectTotal.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.tableTwoDirectTotal ? detail.tableTwoDirectTotal.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.tableTwoDirectTotal ? detail.tableTwoDirectTotal.actTaxAmount : 0,
    actNoTaxAmount: detail.tableTwoDirectTotal ? detail.tableTwoDirectTotal.actNoTaxAmount : 0,
    remark: detail.tableTwoDirectTotal ? detail.tableTwoDirectTotal.remark : '',
    contractAmount: detail.tableTwoDirectTotal ? detail.tableTwoDirectTotal.contractAmount : 0
  })

  res.push({
    title1: '间接成本',
    title2: '管理费用',
    span1: {
      rowspan: 3,
      colspan: 1
    },
    span2: {
      rowspan: 1,
      colspan: 1
    },
    myindex:9,
    budgetTaxAmount: detail.projectManagementAmount ? detail.projectManagementAmount.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.projectManagementAmount ? detail.projectManagementAmount.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.projectManagementAmount ? detail.projectManagementAmount.actTaxAmount : 0,
    actNoTaxAmount: detail.projectManagementAmount ? detail.projectManagementAmount.actNoTaxAmount : 0,
    remark: detail.projectManagementAmount ? detail.projectManagementAmount.remark : ''
  })

  res.push({
    title1: '间接成本',
    title2: '其他',
    span1: {
      rowspan: 0,
      colspan: 0
    },
    span2: {
      rowspan: 1,
      colspan: 1
    },
    myindex:9,
    budgetTaxAmount: detail.otherIndirectAmount ? detail.otherIndirectAmount.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.otherIndirectAmount ? detail.otherIndirectAmount.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.otherIndirectAmount ? detail.otherIndirectAmount.actTaxAmount : 0,
    actNoTaxAmount: detail.otherIndirectAmount ? detail.otherIndirectAmount.actNoTaxAmount : 0,
    remark: detail.otherIndirectAmount ? detail.otherIndirectAmount.remark : ''
  })

  res.push({
    title1: '间接成本',
    title2: '小计',
    span1: {
      rowspan: 0,
      colspan: 0
    },
    span2: {
      rowspan: 1,
      colspan: 1
    },
    myindex:9,
    budgetTaxAmount: detail.tableTwoInDirectTotal ? detail.tableTwoInDirectTotal.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.tableTwoInDirectTotal ? detail.tableTwoInDirectTotal.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.tableTwoInDirectTotal ? detail.tableTwoInDirectTotal.actTaxAmount : 0,
    actNoTaxAmount: detail.tableTwoInDirectTotal ? detail.tableTwoInDirectTotal.actNoTaxAmount : 0,
    remark: detail.tableTwoInDirectTotal ? detail.tableTwoInDirectTotal.remark : ''
  })

  res.push({
    title1: '合同总成本合计',
    title2: '',
    span1: {
      rowspan: 1,
      colspan: 2
    },
    span2: {
      rowspan: 0,
      colspan: 0
    },
    myindex:10,
    budgetTaxAmount: detail.tableTwoAllCostTotal ? detail.tableTwoAllCostTotal.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.tableTwoAllCostTotal ? detail.tableTwoAllCostTotal.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.tableTwoAllCostTotal ? detail.tableTwoAllCostTotal.actTaxAmount : 0,
    actNoTaxAmount: detail.tableTwoAllCostTotal ? detail.tableTwoAllCostTotal.actNoTaxAmount : 0,
    remark: detail.tableTwoAllCostTotal ? detail.tableTwoAllCostTotal.remark : ''
  })

  res.push({
    title1: '合同毛利',
    title2: '',
    span1: {
      rowspan: 1,
      colspan: 2
    },
    span2: {
      rowspan: 0,
      colspan: 0
    },
    myindex:11,
    budgetTaxAmount: detail.tableTwoGrossProfit ? detail.tableTwoGrossProfit.budgetTaxAmount: 0,
    budgetNoTaxAmount: detail.tableTwoGrossProfit ? detail.tableTwoGrossProfit.budgetNoTaxAmount : 0 ,
    actTaxAmount: detail.tableTwoGrossProfit ? detail.tableTwoGrossProfit.actTaxAmount : 0,
    actNoTaxAmount: detail.tableTwoGrossProfit ? detail.tableTwoGrossProfit.actNoTaxAmount : 0,
    remark: detail.tableTwoGrossProfit ? detail.tableTwoGrossProfit.remark : ''
  })

  res.push({
    title1: '合同毛利率',
    title2: '',
    span1: {
      rowspan: 1,
      colspan: 2
    },
    span2: {
      rowspan: 0,
      colspan: 0
    },
    isPct: true,
    myindex:12,
    budgetTaxAmount: detail.tableTwoGrossMarginList ? detail.tableTwoGrossMarginList[0] : 0,
    budgetNoTaxAmount: detail.tableTwoGrossMarginList ? detail.tableTwoGrossMarginList[1] : 0 ,
    actTaxAmount: detail.tableTwoGrossMarginList ? detail.tableTwoGrossMarginList[2] : 0,
    actNoTaxAmount: detail.tableTwoGrossMarginList ? detail.tableTwoGrossMarginList[3] : 0,
    remark: ''
  })


  return res;

}

export const defaultDataTemplate = {

}
// this.projectCostDetailTableData.serviceCost=this.projectCostDetailTableData.serviceCostAnalysis
// this.projectCostDetailTableData.materialCost=this.projectCostDetailTableData.materialCostAnalysis
// this.projectCostDetailTableData.machineCost=this.projectCostDetailTableData.machineCostAnalysis
// this.projectCostDetailTableData.otherDirectCost=this.projectCostDetailTableData.otherDirectCostAnalysis

export function formatEarningCostBasicTable1Data(detail) {
  let res = [];
  if(detail.serviceCostAnalysis && detail.serviceCostAnalysis.length) {
    let length = detail.serviceCostAnalysis.length;
    for(let i=0;i<length;i++) {
      res.push(Object.assign({}, detail.serviceCostAnalysis[i], {title: '劳务费', myindex: (i+1)}));
      if(i == 0) {
        res[i].rowspan = length + 1; // 最后还要有个小计
        res[i].colspan = 1;
      } else {

        res[i].rowspan = 0;
        res[i].colspan = 0;
      }
    }
    res.push(Object.assign({}, (detail.serviceCostTotal || {}), {partyB: '小计', rowspan: 0, colspan: 0, title: '劳务费', hideTaxRateCurrent: true}));
  } else {
    // 如果没有，那就要造假数据放进去，保持表格展示的完整
    res.push(Object.assign({}, defaultDataTemplate, {title: '劳务费', rowspan: 2, colspan: 1, myindex: 1}))
    res.push(Object.assign({}, defaultDataTemplate, {title: '劳务费', rowspan: 0, colspan: 0, partyB: '小计', hideTaxRateCurrent: true}))
  }

  
  let preLength = res.length;
  if(detail.materialCostAnalysis && detail.materialCostAnalysis.length) {
    let length = detail.materialCostAnalysis.length;
    for(let i=0;i<length;i++) {
      res.push(Object.assign({}, detail.materialCostAnalysis[i], {title: '材料费', myindex: (i+1)}));
      if(i == 0) {
        res[preLength + i].rowspan = length + 1;
        res[preLength + i].colspan = 1;
      } else {
        res[preLength + i].rowspan = 0;
        res[preLength + i].colspan = 0;
      }
    }
    res.push(Object.assign({}, (detail.materialCostTotal || {}), {partyB: '小计', rowspan: 0, colspan: 0, title: '材料费', hideTaxRateCurrent: true}));
  } else {
    res.push(Object.assign({}, defaultDataTemplate, {title: '材料费', rowspan: 2, colspan: 1, myindex: 1}))
    res.push(Object.assign({}, defaultDataTemplate, {title: '材料费', rowspan: 0, colspan: 0, partyB: '小计', hideTaxRateCurrent: true}))
  }

  preLength = res.length;
  if(detail.machineCostAnalysis && detail.machineCostAnalysis.length) {
    let length = detail.machineCostAnalysis.length;
    for(let i=0;i<length;i++) {
      res.push(Object.assign({}, detail.machineCostAnalysis[i], {title: '机械费', myindex: (i+1)}));
      if(i == 0) {
        res[preLength + i].rowspan = length + 1;
        res[preLength + i].colspan = 1;
      } else {
        res[preLength + i].rowspan = 0;
        res[preLength + i].colspan = 0;
      }
    }
    res.push(Object.assign({}, (detail.machineCostTotal || {}), {partyB: '小计', rowspan: 0, colspan: 0, title: '机械费', hideTaxRateCurrent: true}));
  } else {
    res.push(Object.assign({}, defaultDataTemplate, {title: '机械费', rowspan: 2, colspan: 1, myindex: 1}))
    res.push(Object.assign({}, defaultDataTemplate, {title: '机械费', rowspan: 0, colspan: 0, partyB: '小计', hideTaxRateCurrent: true}))
  }

  preLength = res.length;
  if(detail.otherDirectCostAnalysis && detail.otherDirectCostAnalysis.length) {
    let length = detail.otherDirectCostAnalysis.length;
    for(let i=0;i<length;i++) {
      res.push(Object.assign({}, detail.otherDirectCostAnalysis[i], {title: '其他直接费', myindex: (i+1)}));
      if(i == 0) {
        res[preLength + i].rowspan = length + 1;
        res[preLength + i].colspan = 1;
      } else {
        res[preLength + i].rowspan = 0;
        res[preLength + i].colspan = 0;
      }
    }
    res.push(Object.assign({}, (detail.otherDirectCostTotal || {}), {partyB: '小计', rowspan: 0, colspan: 0, title: '其他直接费', hideTaxRateCurrent: true}));
  } else {
    res.push(Object.assign({}, defaultDataTemplate, {title: '其他直接费', rowspan: 2, colspan: 1, myindex: 1}))
    res.push(Object.assign({}, defaultDataTemplate, {title: '其他直接费', rowspan: 0, colspan: 0, partyB: '小计', hideTaxRateCurrent: true}))
  }

  if(detail.oneToFourTotal) {
    res.push(Object.assign({}, detail.oneToFourTotal, {
      title: '', rowspan: 1, colspan: 1,partyB: '工料机合计', hideTaxRateCurrent: true
    }))
  } else {
    res.push(Object.assign({}, defaultDataTemplate, {
      title: '', rowspan: 1, colspan: 1,partyB: '工料机合计', hideTaxRateCurrent: true
    }))
  }

  // 项目管理费，只有一条，所以合计和这一条数据是一样的
  if(detail.projectManagementCost) {
    res.push(Object.assign({}, detail.projectManagementCost, {
      title: '项目管理费', rowspan: 2, colspan: 1, myindex: 1
    }))
    const data = {...detail.projectManagementCost};
    data.taxRateCurrent = null;
    res.push(Object.assign({}, data, {
      title: '项目管理费', rowspan: 0, colspan: 0, partyB: '费用合计', hideTaxRateCurrent: true
    }))
  } else {
    res.push(Object.assign({}, defaultDataTemplate, {
      title: '项目管理费', rowspan: 2, colspan: 1, myindex: 1
    }))
    res.push(Object.assign({}, defaultDataTemplate, {
      title: '项目管理费', rowspan: 0, colspan: 0, partyB: '费用合计', hideTaxRateCurrent: true
    }))
  }

  // 内部应转费用,固定那3条
  if(detail.equipDeptCost) {
    res.push(Object.assign({}, detail.equipDeptCost, {
      title: '内部应转费用', rowspan: 4, colspan: 1, partyB: '设备物资部', myindex: 1
    }));
  } else {
    res.push(Object.assign({}, defaultDataTemplate, {
      title: '内部应转费用', rowspan: 4, colspan: 1, partyB: '设备物资部', myindex: 1
    }));
  }

  if(detail.facilityDeptCost) {
    res.push(Object.assign({}, detail.facilityDeptCost, {
      title: '内部应转费用', rowspan: 0, colspan: 0, partyB: '设施场', myindex: 2
    }));
  } else {
    res.push(Object.assign({}, defaultDataTemplate, {
      title: '内部应转费用', rowspan: 0, colspan: 0, partyB: '设施场', myindex: 2
    }));
  }

  if(detail.projectDeptCost) {
    res.push(Object.assign({}, detail.projectDeptCost, {
      title: '内部应转费用', rowspan: 0, colspan: 0, partyB: '工程处', myindex: 3,
    }));
  } else {
    res.push(Object.assign({}, defaultDataTemplate, {
      title: '内部应转费用', rowspan: 0, colspan: 0, partyB: '工程处', myindex: 3
    }));
  }

  if(detail.sixTotal) {
    res.push(Object.assign({}, detail.sixTotal, {
      title: '内部应转费用', rowspan: 0, colspan: 0, partyB: '小计', hideTaxRateCurrent: true
    }));
  } else {
    res.push(Object.assign({}, defaultDataTemplate, {
      title: '内部应转费用', rowspan: 0, colspan: 0, partyB: '小计', hideTaxRateCurrent: true
    }));
  }

  if(detail.fiveAndSixTotal) {
    res.push(Object.assign({}, detail.fiveAndSixTotal, {
      title: '', rowspan: 1, colspan: 1, partyB: '间接费合计', hideTaxRateCurrent: true
    }));
  } else {
    res.push(Object.assign({}, defaultDataTemplate, {
      title: '', rowspan: 1, colspan: 1, partyB: '间接费合计', hideTaxRateCurrent: true
    }));
  }

  if(detail.allTotal) {
    res.push(Object.assign({}, detail.allTotal, {
      title: '', rowspan: 1, colspan: 1, partyB: '合计', hideTaxRateCurrent: true
    }));
  } else {
    res.push(Object.assign({}, defaultDataTemplate, {
      title: '', rowspan: 1, colspan: 1, partyB: '合计', hideTaxRateCurrent: true
    }));
  }

  return res;
}

export function formatProjectCostDetailTableData(detail) {
  let res = formatEarningCostBasicTable1Data(detail);

  // 额外加一些要展示，但没实际数据的内容
  res.push({
    title: '生产部门意见',
    rowspan: 2,
    colspan: 1,
    partyBSpecial: true,
    partyBSpecialRowspan: 1,
    partyBSpecialColumnspan: 15,
    contractContentSpecial: true,
    contractContentRowspan: 0,
    contractContentColumnspan: 0

  })
  res.push({
    title: '生产部门意见',
    rowspan: 0,
    colspan: 0,
    partyB: '部门负责人意见',
    contractContentSpecial: true,
    contractContentRowspan: 1,
    contractContentColumnspan: 14
  })
  res.push({
    title: '集团意见',
    rowspan: 6,
    colspan: 1,
    partyB: '成本合约部意见',
    contractContentSpecial: true,
    contractContentRowspan: 1,
    contractContentColumnspan: 14
  })
  res.push({
    title: '集团意见',
    rowspan: 0,
    colspan: 0,
    partyB: '经营管理部意见',
    contractContentSpecial: true,
    contractContentRowspan: 1,
    contractContentColumnspan: 14
  })
  res.push({
    title: '集团意见',
    rowspan: 0,
    colspan: 0,
    partyB: '设备物资部意见',
    contractContentSpecial: true,
    contractContentRowspan: 1,
    contractContentColumnspan: 14
  })
  res.push({
    title: '集团意见',
    rowspan: 0,
    colspan: 0,
    partyB: '财务审计部意见',
    contractContentSpecial: true,
    contractContentRowspan: 1,
    contractContentColumnspan: 14
  })
  res.push({
    title: '集团意见',
    rowspan: 0,
    colspan: 0,
    partyB: '分管领导审批意见',
    contractContentSpecial: true,
    contractContentRowspan: 1,
    contractContentColumnspan: 14
  })
  res.push({
    title: '集团意见',
    rowspan: 0,
    colspan: 0,
    partyB: '主管领导审批意见',
    contractContentSpecial: true,
    contractContentRowspan: 1,
    contractContentColumnspan: 14
  })
  return res;
}